import React from 'react';

import {translate} from 'iss/strings';
import {useQueryState} from 'iss/hooks/useQueryState';
import {searchContractSuppliers} from 'iss/service/ContractSuppliersService';
import {EditButton, NewButton} from 'iss/widgets/Buttons';
import {ContractSuppliersList} from 'iss/widgets/ContractSuppliersList';
import {FlexItem, FlexRow} from 'iss/widgets/Flex';
import {SuccessBox} from 'iss/widgets/MessageBox';
import {PagedSearchResults, SearchResultScroller, ShowAllResultsButton, TextSearchBar, formatResultCount} from 'iss/widgets/PagedSearchResults';
import BootstrapCheckbox from 'iss/widgets/bootstrap/Checkbox';

function ContractSuppliersListPage() {
    const [search, setSearch] = useQueryState({
      defaults: {query: "", showOnlyPreferred: true,},
      parse: {showOnlyPreferred: val => val == "true"}
    });
    const showDeleteMessage = window.location.search.indexOf("deleteSuccess=true") != -1;

    const getItems = (search, page, size) => {
      return searchContractSuppliers(search.query, page, size, false, search.showOnlyPreferred);
    };

    return <React.Fragment>
      <h1>{translate('contractSuppliers.title')}</h1>
      <SuccessBox id="deleteSuccess" message={showDeleteMessage ? translate('common.deletedSuccessfully') : null} />
      <ContractSupplierSearch search={search} onChange={setSearch}/>
      <PagedSearchResults getItems={getItems} search={search}>
        {(results, resultApi) =>
          <React.Fragment>
            <ContractSupplierToolbar searchResult={results} onShowAll={resultApi.loadAllItems} />
            <SearchResultScroller searchResult={results} onLoadMore={resultApi.loadMoreItems}>
              <ContractSuppliersSearchResult contractSuppliers={results.results}/>
            </SearchResultScroller>
          </React.Fragment>
        }
      </PagedSearchResults>
    </React.Fragment>;
}

function ContractSupplierSearch({search, onChange}) {
  const {query, showOnlyPreferred} = search;
  return <TextSearchBar id="contract-supplier-search" search={query}
    onChange={(newQuery) => onChange({showOnlyPreferred, query: newQuery})} >

    <BootstrapCheckbox id="showOnlyPreferred" className="text-nowrap"
      label="contractSuppliers.showOnlyPreferred"
      value={showOnlyPreferred} onChange={(e) => onChange({query, showOnlyPreferred: Boolean(e.target.checked)})} />

  </TextSearchBar>;
}

function ContractSupplierToolbar({searchResult, onShowAll}) {
  return <FlexRow alignItems="center" minHeight="3em" justifyContent="space-between">
      <FlexItem flex="none">
        {formatResultCount(searchResult)}
        <ShowAllResultsButton searchResult={searchResult} limit={1000} onShowAll={onShowAll} />
      </FlexItem>
      <FlexItem flex="none">
        <NewButton id="new-supplier" link="/contract-supplier/new" text={translate('contractSuppliers.newContractSupplier')} />
      </FlexItem>
    </FlexRow>;
}

function ContractSuppliersSearchResult(props) {
  return <ContractSuppliersList {...props} extraColumns={[
    {
      header: translate('common.editOrView'),
      accessor: contractSupplier =>
      <EditButton className="edit-contract-supplier" id={"edit-contract-supplier-"+contractSupplier.id}
        link={"/contract-supplier/"+contractSupplier.id}
        alt={translate('contractSuppliers.editContractSuppliersTooltip')}
      />
    }
  ]}/>;
}

export default ContractSuppliersListPage;


// WEBPACK FOOTER //
// ./modules/issFrontend/pages/ContractSuppliersListPage.jsx